import { z } from "zod";

/**
 * Provider-native data attached to a persisted content part, keyed by provider.
 * Transparent bag: the core never inspects it — each reconstruction adapter
 * reads its own provider key and validates only the field it consumes.
 * Open by provider key, so any provider passes through unstripped.
 */
export const providerMetadataSchema = z.record(z.string(), z.record(z.string(), z.unknown()));

export type ProviderMetadata = z.infer<typeof providerMetadataSchema>;
